export const CNPJ_RESPONSE = 'CNPJ_RESPONSE';
export const CNPJ_ERROR = 'CNPJ_ERROR';
export const CNPJ_DATA = 'CNPJ_DATA';
